import React, { useState, useEffect, useCallback } from 'react';
import { LoginForm } from '../components/tailwind';
import NewCustomer from '../components/NewCustomer';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { login } from '../actions/user.actions';
import Alert from '../components/Alert';
import ErrorBoundary from '../components/tailwind/ErrorBoundary';

const SignInPage = ({ flash }) => {
  const dispatch = useAppDispatch();
  const { success: userRegisterSuccess, data: userRegisterData } = useSelector((state) => state.userRegister);

  const [successMessage, setSuccessMessage] = useState('');

  const onSubmit = useCallback(
    (data) => {
      dispatch(login(data));
    },
    [dispatch]
  );

  useEffect(() => {
    if (localStorage.getItem('successMessage')) {
      setSuccessMessage({ text: localStorage.getItem('successMessage'), duration: 3500 });
      localStorage.removeItem('successMessage');
    }
  }, []);

  return (
    <div className='sign-in-page'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <ErrorBoundary>
              <h2 className='sign-in-page__title'>My Account</h2>

              {flash?.success && (
                <Alert type='success' shown>
                  {flash.success}
                </Alert>
              )}

              {flash?.error && (
                <Alert type='danger' shown>
                  {flash.error}
                </Alert>
              )}

              {(successMessage || userRegisterSuccess) && (
                <Alert shown type='success' duration={userRegisterSuccess ? false : successMessage.duration}>
                  {userRegisterData?.message || successMessage.text}
                </Alert>
              )}
            </ErrorBoundary>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6 border-md-right px-0 px-sm-3 order-0'>
            <ErrorBoundary message='Something went wrong with login form'>
              <LoginForm onSubmit={onSubmit} />
            </ErrorBoundary>
          </div>
          <div className='col-md-6 px-0 px-sm-3 order-5'>
            <ErrorBoundary message='Something went wrong with signup form'>
              <NewCustomer />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
